import { Modal } from 'react-bootstrap';

export default function PageLimitModal(props) {
	const { showPageLimit, handleShowPageLimit, handleRadio, pageLimitValue } = props;
	return (
		<Modal show={showPageLimit} onHide={handleShowPageLimit} className="sortModal" centered>
			<Modal.Header closeButton>
				<Modal.Title>Select Page Limit</Modal.Title>
			</Modal.Header>
			<Modal.Body>
			<div>
					<input
						id="10"
						style={{ cursor: 'pointer' }}
						type="radio"
						label="10"
						className="mb-2"
						value="10"
						checked={pageLimitValue === '50'}
						onChange={(e) => {
							handleRadio(e);
						}}
					/>
					<label style={{ marginLeft: '15px', cursor: 'pointer' }} htmlFor="10">
						10
					</label>
				</div>
				<div style={{ marginTop: '15px' }}>
					<input
						id="50"
						style={{ cursor: 'pointer' }}
						type="radio"
						label="50"
						className="mb-2"
						value="50"
						checked={pageLimitValue === '50'}
						onChange={(e) => {
							handleRadio(e);
						}}
					/>
					<label style={{ marginLeft: '15px', cursor: 'pointer' }} htmlFor="50">
						50
					</label>
				</div>
				<div style={{ marginTop: '15px' }}>
					<input
						id="100"
						style={{ cursor: 'pointer' }}
						type="radio"
						label="100"
						className="mb-2"
						value="100"
						checked={pageLimitValue === '100'}
						onChange={(e) => {
							handleRadio(e);
						}}
					/>
					<label style={{ marginLeft: '15px', cursor: 'pointer' }} htmlFor="100">
						100
					</label>
				</div>
				<div style={{ marginTop: '15px' }}>
					<input
						id="200"
						style={{ cursor: 'pointer' }}
						type="radio"
						label="200"
						className="mb-2"
						value="200"
						checked={pageLimitValue === '200'}
						onChange={(e) => {
							handleRadio(e);
						}}
					/>
					<label style={{ marginLeft: '15px', cursor: 'pointer' }} htmlFor="200">
						200
					</label>
				</div>
				<div style={{ marginTop: '15px' }}>
					<input
						id="300"
						style={{ cursor: 'pointer' }}
						type="radio"
						label="300"
						className="mb-2"
						value="300"
						checked={pageLimitValue === '300'}
						onChange={(e) => {
							handleRadio(e);
						}}
					/>
					<label style={{ marginLeft: '15px', cursor: 'pointer' }} htmlFor="300">
						300
					</label>
				</div>
				<div style={{ marginTop: '15px' }}>
					<input
						id="400"
						style={{ cursor: 'pointer' }}
						type="radio"
						label="400"
						className="mb-2"
						value="400"
						checked={pageLimitValue === '400'}
						onChange={(e) => {
							handleRadio(e);
						}}
					/>
					<label style={{ marginLeft: '15px', cursor: 'pointer' }} htmlFor="400">
						400
					</label>
				</div>
				<div style={{ marginTop: '15px' }}>
					<input
						id="500"
						style={{ cursor: 'pointer' }}
						type="radio"
						label="500"
						className="mb-2"
						value="500"
						checked={pageLimitValue === '500'}
						onChange={(e) => {
							handleRadio(e);
						}}
					/>
					<label style={{ marginLeft: '15px', cursor: 'pointer' }} htmlFor="500">
						500
					</label>
				</div>
			</Modal.Body>
		</Modal>
	);
}
